module.exports = __webpack_public_path__ + "static/img/pic-zhou5.2ddff2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-zhou5.jpg
// module id = 937
// module chunks = 0